import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AppConfigService } from 'src/app/shared/services/app-config.service';
import { AppUpdateService } from 'src/app/shared/services/app-update.service';
import { UtilService } from 'src/app/shared/services/util.service';

@Injectable({
  providedIn: 'root'
})
export class ZohoService {

  constructor(
    private appUpdateService: AppUpdateService,
    private confService: AppConfigService,
    private http: HttpClient,
    private router: Router,
    private utilService: UtilService
  ) { }

  private checkAppUpdate(res: HttpResponse<any>): HttpResponse<any> {
    if (res.headers?.has('x-appversion')) {
      this.appUpdateService.appVersion.emit(res.headers.get('x-appversion'))
    }
    return res
  }

  enviar(data: any): Promise<any> {
    const config = this.confService.config
    const onHold = `${config['API_PROT']}://${config['API_HOST']}${config['APP_ON_HOLD']}`
    const url = 'https://crm.zoho.com/crm/WebToContactForm'
    const body = new URLSearchParams()

    body.set('xnQsjsdp', '2534633293f338d62fa3b672eb5c3ef9c5c37dd8f29173cd47fae7898fe52deb')
    body.set('zc_gad', '')
    body.set('xmIwtLD', '3036c8c7c078788d6b98673e180415ba71913fcfc117a08c8d61ec6f4f42b284f17cff45080dbab6bd48b26cd90a79ff')
    body.set('actionType', 'TGVhZHM=')
    body.set('returnURL', onHold)
    body.set('ldeskuid', '')
    body.set('LDTuvid', '')

    body.set('First Name', data.firstName)
    body.set('Last Name', data.lastName)
    body.set('Email', data.email)
    body.set('Mobile', data.phone)
    body.set('Lead Source', 'Organic')
    body.set('aG9uZXlwb3Q', '')

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    })

    return this.http.post(url, body.toString(), {
      headers, responseType: 'text', observe: 'response'
    })// 👈 ESSENCIAL pra acessar headers
      .toPromise()
      .then((res: HttpResponse<string>) => {
        this.checkAppUpdate(res)
        return onHold
      })
      .catch(err => {
        return this.utilService.handleError(err, this.router)
      })
  }
}